import { Header } from './components/Header';
import { List } from './components/List';
import { MoreItems } from './components/MoreItems';
import { NewsletterDialog } from './components/NewsletterDialog';
import { ChangelogProvider } from './context/ChangelogContextProvider';
import { NewsletterProvider } from './context/NewsletterContextProvider';

export default function ChangelogExtension() {
  return (
    <ChangelogProvider>
      <NewsletterProvider>
        <Header />
        <List />
        <MoreItems />
        <NewsletterDialog />
      </NewsletterProvider>
    </ChangelogProvider>
  );
}
